import {LitElement, html, css} from 'lit';


export class Username extends LitElement {
    static get styles() {
        return css`
            .username {
                color: var(--username-color, #ffffff);
                margin-right: var(--username-margin-right, 0.2em);
            }
            .username .icon {
                width: 1rem;
                margin-left: 0.2rem;
                top: 0.2em;
                position: relative;
            }
            .username.username--admin, .username.username--admin.username--patreon, .username.username--admin.username--verified {
                font-weight: bold;
                color: var(--username-admin-color, #9b0000);
            }
    
            .username.username--patreon {
                font-weight: bold;
                color: var(--username-patreon-color, #ce602b);
            }
            .username.username--verified {
                font-weight: bold;
                color: var(--username-verified-color, #00e479);
            }
            
            .username.username--alt {
                border-bottom: 1px dashed gray;
            }

            .username .icon.icon--admin path {
                fill: var(--username-icon-admin-color, #ffffff);
            }
            .username .icon.icon--verified path {
                fill: var(--username-icon-verified-color, #ff6c00);
            }
            .username .icon.icon--patreon path {
                fill: var(--username-icon-patreon-color, #ce602b);
            }
        `;
    }

    static get properties() {
        return {
            user_id: {type: Number},
            username: {type: String},
            profilename: {type: String},
            staff: {type: Boolean,
                hasChanged(newVal, oldVal) {
                  return newVal !== oldVal;
                },
                converter: {
                  fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' ) {
                      return true;
                    }
                    return false;
                  }
                }
            },
            patron: {type: Boolean,
                hasChanged(newVal, oldVal) {
                  return newVal !== oldVal;
                },
                converter: {
                  fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' ) {
                      return true;
                    }
                    return false;
                  }
                }
            },
            verified: {type: Boolean,
                hasChanged(newVal, oldVal) {
                  return newVal !== oldVal;
                },
                converter: {
                  fromAttribute: (value, type) => {
                    if (value === 'true' || value === 'True' || value == '1' ) {
                      return true;
                    }
                    return false;
                  }
                }
            },
        }
    }
    
    constructor() {
        super();
        this.user_id = 0;
        this.username = 'User';
        this.profilename = '';
        this.staff = false;
        this.patron = false;
        this.verified = false;
    }
    
    getPrimaryUsername() {
        if (this.profilename != '') {
            return this.profilename;
        }
        return this.username;
    }

    getAdminSvgTemplate() {
        if (this.staff) {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="empire" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" class="icon icon--admin">
                <path fill="currentColor" d="M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z" class=""></path>
            </svg>`;
        }
        return html``;
    }

    getPatreonSvgTemplate() {
        if (this.patron && !this.staff) {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="icon icon--patreon"><path fill="currentColor" d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" class=""></path></svg>`;
        }
        return html``;
    }

    getVerifiedSvgTemplate() {
        if (this.verified && !this.staff && !this.patron) {
            return html`<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="shield-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="icon icon--verified">><path fill="currentColor" d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z" class=""></path></svg>`;
        }
        return html``;
    }

    getProfileNameTitleTemplate() {
        if (this.profilename != '') {
            return html`title="${this.username}"`;
        }
        return html``;
    }

    render() {
        return html`
            <span title="${this.username}" class="username ${this.staff ? 'username--admin' : ''} ${this.patron ? 'username--patreon' : ''} ${this.verified ? 'username--verified' : ''} ${this.profilename != '' ? 'username--alt' : ''}">${this.getPrimaryUsername()}${this.getAdminSvgTemplate()}${this.getPatreonSvgTemplate()}${this.getVerifiedSvgTemplate()}</span>
        `;
    }
}

window.customElements.define('username-element', Username);